export const sendMessageToWorkerWithTransfer = (message, transfer) => {
    navigator.serviceWorker.ready.then((registration) => {
        const activeServiceWorker = registration.active

        if (!activeServiceWorker) {
            // This is not supposed to happen according to the documentation. But it does.
            return
        }

        if (transfer) {
            activeServiceWorker.postMessage(message, transfer)
        } else {
            activeServiceWorker.postMessage(message)
        }
    })
}

// Send a message to the serviceWorker
export const sendMessageToWorker = (message) => {
    try {
        sendMessageToWorkerWithTransfer(message)
    } catch (error) {
        // No need to log or do anything.
        // if service worker isn't defined yet
    }
}

export const WORKER_RESPONSE_TIMEOUT_MS = 10000

export const sendMessageToWorkerWithResponse = (message) => {
    // This wraps the message posting/response in a promise, which will
    // resolve if the response doesn't contain an error, and reject with
    // the error if it does. If you'd prefer, it's possible to call
    // controller.postMessage() and set up the onmessage handler
    // independently of a promise, but this is a convenient wrapper.
    return new Promise(function (resolve, reject) {
        const messageChannel = new MessageChannel()
        const timeoutId = setTimeout(() => {
            messageChannel.port1.onmessage = null
            reject(new Error('Service worker response timed out'))
        }, WORKER_RESPONSE_TIMEOUT_MS)
        messageChannel.port1.onmessage = function (event) {
            clearTimeout(timeoutId)
            if (event.data && event.data.error) {
                reject(event.data.error || 'Un problème est survenu')
            } else {
                resolve(event.data)
            }
        }

        // This sends the message data as well as transferring
        // messageChannel.port2 to the service worker.
        // The service worker can then use the transferred port to reply
        // via postMessage(), which will in turn trigger the onmessage
        // handler on messageChannel.port1.
        // See
        // https://html.spec.whatwg.org/multipage/workers.html#dom-worker-postmessage
        sendMessageToWorkerWithTransfer(message, [messageChannel.port2])
    })
}

export const handlePushNotification = (event) => {
    if (event?.data?.clear_cache) {
        sendMessageToWorker({ 'clear cache': event.data.clear_cache })
    }
}
